module.exports = __webpack_public_path__ + "static/img/error.623eba5c.png";